import { render, staticRenderFns } from "./MyMatching.vue?vue&type=template&id=4c4a2db4&scoped=true"
import script from "./MyMatching.vue?vue&type=script&lang=js"
export * from "./MyMatching.vue?vue&type=script&lang=js"
import style0 from "./MyMatching.vue?vue&type=style&index=0&id=4c4a2db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a2db4",
  null
  
)

export default component.exports